export default function ImportCalendarWarning({ warnings = [] }: { warnings?: string[] }) {
  if (!warnings.length) return null
  return <section role="note" aria-label="Weekly calendar adjustment" className="mb-6 rounded-xl border border-stone/30 bg-white p-6 text-text-primary">
    <h2 className="font-heading text-xl font-semibold">Weekly dates will be adjusted</h2>
    <ul className="mt-3 space-y-3 text-sm">{warnings.map(warning => <li key={warning}>{warning}</li>)}</ul>
    <p className="mt-3 text-sm font-semibold">Informational — this adjustment does not block import or require an additional checkbox. Confirming the saved preview approves these adjusted destination dates.</p>
  </section>
}
